(function () {
  'use strict';

  var WIDGET_SELECTOR = 'body.template-index .jdgm-cards-carousel';
  var TRANSITION_MS = 450;
  var CLONE_COUNT = 4;

  function realCards(rail) {
    return Array.prototype.slice.call(rail.querySelectorAll(':scope > .jdgm-carousel-item')).filter(function (card) {
      return !card.classList.contains('jdgm-clone-before') && !card.classList.contains('jdgm-clone-after');
    });
  }

  function cloneCard(card, position) {
    var clone = card.cloneNode(true);
    clone.classList.remove('active', 'jdgm-clone-before', 'jdgm-clone-after');
    clone.classList.add(position === 'before' ? 'jdgm-clone-before' : 'jdgm-clone-after');
    clone.setAttribute('aria-hidden', 'true');
    return clone;
  }

  function reviewVideoSource(review) {
    var hosted = Array.isArray(review.media_platform_hosted_video_infos) &&
      review.media_platform_hosted_video_infos[0];
    var externalId = Array.isArray(review.video_external_ids) && review.video_external_ids[0];

    if (hosted) {
      if (hosted.hosting_vendor === 'vimeo') {
        return 'https://player.vimeo.com/video/' + encodeURIComponent(hosted.external_id) +
          '?autoplay=1&autopause=0';
      }
      if (hosted.media_platform_name === 'yt') {
        return 'https://www.youtube.com/embed/' + encodeURIComponent(hosted.media_platform_url) +
          '?autoplay=1&playsinline=1';
      }
      if (hosted.external_id) {
        return 'https://iframe.videodelivery.net/' + encodeURIComponent(hosted.external_id) +
          '?autoplay=true&controls=true';
      }
    }

    if (externalId) {
      return 'https://player.vimeo.com/video/' + encodeURIComponent(externalId) +
        '?autoplay=1&autopause=0';
    }

    return '';
  }

  function ensureVideoModal() {
    var modal = document.querySelector('.parans-judge-video-modal');
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'parans-judge-video-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Review video');
    modal.hidden = true;
    modal.innerHTML =
      '<button class="parans-judge-video-modal__overlay" type="button" aria-label="Close review video"></button>' +
      '<div class="parans-judge-video-modal__content">' +
        '<button class="parans-judge-video-modal__close" type="button" aria-label="Close review video">&times;</button>' +
        '<iframe class="parans-judge-video-modal__frame" title="Customer review video" ' +
          'allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>' +
      '</div>';
    document.body.appendChild(modal);

    function closeModal() {
      modal.hidden = true;
      modal.querySelector('.parans-judge-video-modal__frame').src = '';
      document.body.classList.remove('has-parans-judge-video-modal');
    }

    modal.querySelectorAll('[aria-label="Close review video"]').forEach(function (button) {
      button.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });

    modal.openVideo = function (src) {
      modal.querySelector('.parans-judge-video-modal__frame').src = src;
      modal.hidden = false;
      document.body.classList.add('has-parans-judge-video-modal');
      modal.querySelector('.parans-judge-video-modal__close').focus();
    };
    return modal;
  }

  function bindVideoPlayback(widget) {
    if (widget.dataset.paransMediaReady === 'true') return;
    widget.dataset.paransMediaReady = 'true';

    widget.querySelectorAll('.jdgm-card.jdgm-video-card').forEach(function (card) {
      var button = card.querySelector('.jdgm-video-control-play');
      var source = card.dataset.paransVideoSource;
      if (!button || !source) return;

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        ensureVideoModal().openVideo(source);
      }, true);
    });
  }

  function initWidget(widget) {
    if (widget.dataset.paransLoopReady === 'true') return true;
    var blockId = widget.getAttribute('data-jdgm-block-id');
    var mode = window.jdgmCarouselMode && window.jdgmCarouselMode[blockId];
    if (
      widget.classList.contains('jdgm-hidden') ||
      !mode ||
      !Array.isArray(mode.reviews) ||
      !mode.reviews.length
    ) return false;

    var sourceContent = widget.querySelector('.jdgm-content');
    var sourceRail = sourceContent && sourceContent.querySelector('.jdgm-videos-container');
    var sourceCards = sourceRail && realCards(sourceRail);

    if (!sourceCards || sourceCards.length < 2) return false;

    var content = widget.querySelector('.jdgm-content');
    var wrapper = content.querySelector('.jdgm-cards-wrapper');
    var rail = content.querySelector('.jdgm-videos-container');
    var previous = content.querySelector('[aria-label="Previous slide"]');
    var next = content.querySelector('[aria-label="Next slide"]');
    if (!wrapper || !rail || !previous || !next) return false;

    var cards = sourceCards.map(function (card, sourceIndex) {
      var videoSource = reviewVideoSource(mode.reviews[sourceIndex]);
      card.classList.remove('active', 'jdgm-clone-before', 'jdgm-clone-after');
      card.removeAttribute('aria-hidden');
      card.dataset.paransSourceIndex = String(sourceIndex);
      if (videoSource) card.dataset.paransVideoSource = videoSource;
      return card;
    });
    var buffer = Math.min(CLONE_COUNT, cards.length);
    var index = buffer;
    var pending = 0;
    var moving = false;
    var finishTimer = 0;
    var autoplayTimer = 0;
    var pointerStartX = null;

    var nativeCarousel = widget._videoCarouselInstance;
    if (nativeCarousel && typeof nativeCarousel.stopTimer === 'function') nativeCarousel.stopTimer();
    wrapper.classList.add('parans-judge-loop__viewport');
    rail.classList.add('parans-judge-loop__rail');
    while (rail.firstChild) rail.removeChild(rail.firstChild);
    cards.slice(-buffer).forEach(function (card) { rail.appendChild(cloneCard(card, 'before')); });
    cards.forEach(function (card) { rail.appendChild(card); });
    cards.slice(0, buffer).forEach(function (card) { rail.appendChild(cloneCard(card, 'after')); });
    rail.style.transform = '';
    rail.style.transition = 'none';

    function stride() {
      var first = rail.children[0];
      var second = rail.children[1];
      if (!first) return 0;
      if (second) return second.offsetLeft - first.offsetLeft;
      return first.getBoundingClientRect().width;
    }

    function render(animate) {
      var distance = stride() * index;
      rail.style.transition = animate ? 'transform ' + TRANSITION_MS + 'ms cubic-bezier(.36,.66,.04,1)' : 'none';
      rail.style.transform = 'translate3d(' + -distance + 'px,0,0)';
    }

    function finishMove() {
      window.clearTimeout(finishTimer);
      if (!moving) return;

      if (index >= buffer + cards.length) {
        index -= cards.length;
        render(false);
      } else if (index < buffer) {
        index += cards.length;
        render(false);
      }

      moving = false;
      if (pending) runQueue();
    }

    function runQueue() {
      var direction;
      if (moving || !pending) return;
      direction = pending > 0 ? 1 : -1;
      pending -= direction;
      index += direction;
      moving = true;
      render(true);
      finishTimer = window.setTimeout(finishMove, TRANSITION_MS + 80);
    }

    function step(direction, resetAutoplay) {
      pending += direction;
      runQueue();
      if (resetAutoplay) restartAutoplay();
    }

    function restartAutoplay() {
      window.clearInterval(autoplayTimer);
      autoplayTimer = window.setInterval(function () { step(1, false); }, 5000);
    }

    previous.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      step(-1, true);
    }, true);
    next.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      step(1, true);
    }, true);
    rail.addEventListener('transitionend', function (event) {
      if (event.target === rail && event.propertyName === 'transform') finishMove();
    });
    wrapper.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse') pointerStartX = event.clientX;
    });
    wrapper.addEventListener('pointerup', function (event) {
      if (pointerStartX == null) return;
      var delta = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(delta) > 40) step(delta < 0 ? 1 : -1, true);
    });
    wrapper.addEventListener('pointercancel', function () { pointerStartX = null; });
    widget.addEventListener('mouseenter', function () { window.clearInterval(autoplayTimer); });
    widget.addEventListener('mouseleave', restartAutoplay);
    widget.addEventListener('focusin', function () { window.clearInterval(autoplayTimer); });
    widget.addEventListener('focusout', restartAutoplay);
    window.addEventListener('resize', function () { render(false); });

    widget.classList.add('is-parans-loop');
    widget.dataset.paransLoopReady = 'true';
    bindVideoPlayback(widget);
    window.requestAnimationFrame(function () { render(false); });
    restartAutoplay();
    return true;
  }

  function scan(attempt) {
    var widgets = document.querySelectorAll(WIDGET_SELECTOR);
    var ready = false;
    widgets.forEach(function (widget) { ready = initWidget(widget) || ready; });
    if (!ready && (attempt || 0) < 240) {
      window.setTimeout(function () { scan((attempt || 0) + 1); }, 250);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(0); });
  else scan(0);
  document.addEventListener('shopify:section:load', function () { scan(0); });
})();
